module.exports = "/legacy/40ea2a07b1077a79de188e7bb4e24e1f.svg";